import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export const Hero = () => {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-[100vh] flex items-center pt-20 overflow-hidden"
        >
            <img
                src="https://images.pexels.com/photos/8143668/pexels-photo-8143668.jpeg"
                alt="Luxury Australian family home with landscaped garden — Finance Wealth, Australia-wide mortgage broker"
                className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 hero-overlay" />

            <div className="relative container-prose py-24 md:py-32 text-white">
                <div className="max-w-3xl animate-fade-up">
                    <div className="flex items-center gap-3 text-[#E8DCC4]">
                        <span className="w-10 h-px bg-[#C69C6D]" />
                        <span className="text-[11px] tracking-[0.3em] uppercase font-semibold">Australia-Wide Mortgage Brokerage</span>
                    </div>
                    <h1 className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-medium">
                        Australia-Wide Mortgage Broker for <em className="text-[#E8C997] font-light">Home Loans, Refinance &amp; Investment Finance</em>
                    </h1>
                    <p className="mt-8 text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed font-light">
                        Personalised home loan, refinance and investment finance advice from {BUSINESS.broker} — qualified
                        mortgage broker with access to 60+ Australian lenders.
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row gap-4">
                        <Link to="/contact" data-testid="hero-cta-primary" className="btn-accent">
                            Book a free consultation
                            <ArrowRight className="w-4 h-4" />
                        </Link>
                        <a href={`tel:${BUSINESS.phoneTel}`} data-testid="hero-cta-call" className="inline-flex items-center justify-center gap-2 border border-white/40 text-white px-7 py-3.5 rounded-sm font-medium text-sm tracking-wide hover:bg-white/10 transition-all duration-300">
                            <Phone className="w-4 h-4" />
                            {BUSINESS.phone}
                        </a>
                    </div>

                    <div className="mt-14 flex items-center gap-8 text-white/80 text-sm">
                        <div>
                            <div className="font-serif text-3xl text-white">60+</div>
                            <div className="text-xs tracking-widest uppercase text-white/60 mt-1">Lenders</div>
                        </div>
                        <div className="w-px h-10 bg-white/20" />
                        <div>
                            <div className="font-serif text-3xl text-white">98%</div>
                            <div className="text-xs tracking-widest uppercase text-white/60 mt-1">Approval</div>
                        </div>
                        <div className="w-px h-10 bg-white/20" />
                        <div>
                            <div className="font-serif text-3xl text-white">$420M+</div>
                            <div className="text-xs tracking-widest uppercase text-white/60 mt-1">Settled</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
